module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pl-dialog', {
    attrs: {
      "padding": "2em 4em",
      "height": "450px"
    }
  }, [_c('div', {
    staticClass: "flex justify-between pv2"
  }, [_c('div', {
    staticClass: "tc w-100"
  }, [_c('span', {
    staticClass: "b header-title",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.course_title))]), _vm._v(" "), (!_vm.course.is_archived) ? _c('span', {
    staticClass: "course-link justify-center items-center",
    on: {
      "click": _vm.goToCourse
    }
  }, [_c('a', {
    staticClass: "flex justify-center items-center",
    attrs: {
      "target": "_blank"
    }
  }, [_vm._v("\n            Go to this course "), _c('i', {
    staticClass: "fas fa-external-link-alt"
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.loaded_course) ? _c('div', {
    staticClass: "flex flex-column"
  }, [_c('div', {
    staticClass: "primary-teacher pv2 ph4"
  }, [_c('span', {
    staticClass: "field-header b"
  }, [_vm._v(" Primary Teachers ")]), _vm._v(" "), _c('multiselect', {
    staticClass: "border-select",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "options": _vm.teachers,
      "multiselect": false,
      "selected": _vm.selected_teacher,
      "label": "name",
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "track-by": "id",
      "limit": 1,
      "placeholder": "Select teacher"
    },
    model: {
      value: (_vm.selected_teacher),
      callback: function($$v) {
        _vm.selected_teacher = $$v
      },
      expression: "selected_teacher"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "co-teacher pv2 ph4"
  }, [_c('span', {
    staticClass: "field-header b"
  }, [_vm._v(" Co-teacher(s) ")]), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "options": _vm.teachers,
      "multiple": true,
      "selected": _vm.selected_co_teachers,
      "label": "name",
      "max-height": 150,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "track-by": "id",
      "limit": 1,
      "placeholder": "Select co-teacher(s)"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.selected_co_teachers.length > 1 && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v("\n              " + _vm._s(_vm.selected_co_teachers.length) + " co-teachers selected\n            ")]) : _vm._e()]
      }
    }], null, false, 2775850892),
    model: {
      value: (_vm.selected_co_teachers),
      callback: function($$v) {
        _vm.selected_co_teachers = $$v
      },
      expression: "selected_co_teachers"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.loaded_course) ? _c('div', {
    staticClass: "flex justify-center items-center pv3",
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_c('pl-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": _vm.teachers_changed || _vm.same_teacher_co_teacher
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCourseTeachers.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Save\n      ")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-01bb5a12!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/courses/courseDetailsModal.vue
// module id = 2080
// module chunks = 61